<template>
    <div class="Experimentlist">
        <el-row>
            <el-col :xs="24" :sm="24" :lg="24" :xl="24">
                <div class="contentl">
                    <p class="tit">
                        Experiment list
                    </p>
                    <div class="break" style="font-size:14px;margin-left:20px;margin-bottom:15px;float:left;margin-top:28px;"><span>{{eduName}}</span></div>
                    <!-- <el-radio-group v-model="radio1" class="rowtab2" @change="switcs" v-if="swit">
                        <el-radio-button label="免费" class="buttontab2"></el-radio-button>
                        <el-radio-button label="全部" class="buttontab2"></el-radio-button>
                    </el-radio-group>
                    <el-radio-group v-model="radio1" class="rowtab2" @change="switcs2" v-if="swit2">
                        <el-radio-button label="免费" class="buttontab2"></el-radio-button>
                        <el-radio-button label="全部" class="buttontab2"></el-radio-button>
                    </el-radio-group> -->
                    <ul>
                        <li>
                        <el-input placeholder="Experiment name to search" clearable v-model="search" @keyup.enter.native="searchto" class="input-with-select" v-if="inpu" @change="closeSearch">
                                <el-button slot="append" @click="searchto"><i class="magnifier"></i></el-button>
                                <el-button slot="append" @click="Rescreening" style="border-left:1px solid #DCDFE6;"><i class="refresh"></i></el-button>
                        </el-input>
                        <el-input placeholder="Experiment name to search" clearable v-model="search" @keyup.enter.native="searchto2" class="input-with-select" v-if="inpu2" @change="closeSearch2">
                                <el-button slot="append" @click="searchto2"><i class="magnifier"></i></el-button>
                                <el-button slot="append" @click="Rescreening2" style="border-left:1px solid #DCDFE6;"><i class="refresh"></i></el-button>
                        </el-input>
                        </li>
                    </ul>
                </div>
            </el-col>
        </el-row>
        <el-row style="margin:10px;">
            <el-col :xs="24" :sm="24" :lg="24" :xl="24">
                <div class="list" v-if="itemOk">
                    <div class="noshow" v-if="dataList==''">
                        <span>There is no experiment under this classification</span>
                        <p><img src="../../assets/images/portal/noex.png" alt=""></p>
                    </div>
                    <el-row :gutter="20">
                        <el-col :xs="12" :sm="8" :lg="8" :xl="8" class="item" v-for="(item,index) in dataList" :key="index" v-loading="loading">
                        <div class="itemIn">
                            <div class="pic" @click="infoex(item)">
                                <el-image fit="cover" :src="imageChanges[index]" :alt="item.title" v-loading="loading" :title="item.englishTitle">
                                    <div slot="error" class="image-slot">
                                        <img src="../../assets/images/portal/nophoto.png">
                                    </div>
                                </el-image>
                                <!-- <img :src="item.fileThumbnail" :alt="item.title" :title="item.explanatoryNote" @error="errorUserPhoto"> -->
                                <div class="pichover" v-if="false">begin</div>
                                <!-- <div class="tbtj" :class="{'box3':item.isStudy == 1}">
                                    <b class="left-top">{{item.isStudy | isStudy}}</b>
                                </div> -->
                                <!-- <div class="box" :class="{'box2':item.collectFees==1}">
                                    <b class="right-top">{{item.collectFees | isCollectFees}}</b>
                                </div> -->
                            </div>
                            <!-- 收藏用小星星 -->
                            <!-- <div class="collection" @click="toggle(index,item)">
                                <i class="collectioni" :class="item.collect == true ? star:''"></i>
                            </div> -->
                            <h5 class="titl">
                                <i :class="{'isRecomm':item.isRecomm==1}"></i>
                                <el-tooltip class="item" effect="light" :content="item.englishTitle" placement="top">
                                    <span style="margin-bottom:0;">{{item.englishTitle}}</span>
                                </el-tooltip>
                            </h5>
                            <div class="pick">
                                <!-- <p>评分：
                                    <el-rate
                                        v-model="item.average"
                                        disabled
                                        disabled-void-color="#c8c8c8"
                                        >
                                    </el-rate>
                                </p> -->
                                <p><i class="el-icon-view" style="margin-right:6px;"></i>Views：
                                    <span>{{item.browseNum}}</span>
                                </p>
                            </div>
                          </div>
                        </el-col>
                    </el-row>
                    <div class="paginations" v-if="pagin">
                        <el-pagination
                            background
                            hide-on-single-page
                            layout="prev, pager, next"
                            :total="pageData.total"
                            @current-change="pageChange"
                            :current-page.sync="page"
                            :page-size='12'
                            >
                        </el-pagination>
                    </div>
                    <div class="paginations" v-if="pagin2">
                        <el-pagination
                            background
                            hide-on-single-page
                            layout="prev, pager, next"
                            :total="pageData.total"
                            @current-change="pageChange2"
                            :current-page.sync="page"
                            :page-size='12'
                            >
                        </el-pagination>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import request from '@/utils/request'

export default {
    // props:['src'],
    data(){
        return{
            appIDX:'',
            strReady:'',
            titleNameKey:'',
            itemOk:false,
            isStudy:'',
            imageChanges:[],
            userId:0,
            star:'collection-2',
            // url:'https://i.loli.net/2019/07/31/5d40fc0c0704d86318.png',
            errorUserPhoto:'https://i.loli.net/2019/07/31/5d40ffb611a2f82333.png',
            page:0,
            loading:false,
            radio1:'全部',
            swit:false,
            swit2:false,
            inpu:false,
            inpu2:false,
            pagin:false,
            pagin2:false,
            isfree:'',
            search: '',
            themeType:'',
            materialType:'',
            infoNumber:'',
            // type:'',
            dataList:[{}],
            eduId:'',
            eduName:'',
        pageData:{
            currentPage:1,
            pagesize:12,
            pagenumber:0,
            total:0,
            average:0,
        },
      }
    },
　　filters: {
        isCollectFees: function (value) {
            if(value==0){
                return 'gratis'
            }else if(value==1){
                return 'charge'
            }
        },
        // isStudy: function (value) {
        //     if(value==0){
        //         return '同步'
        //     }else if(value==1){
        //         return '探究'
        //     }
        // },
        // isRecomm: function (value) {
        //     if(value==0){
        //         return '推荐'
        //     }else if(value==1){
        //         return '不推荐'
        //     }
        // },
　　},
    created(){
        this.getinfo();
    },
    mounted(){
    },
    watch: {
        swit2(nval, oval){
            console.log(nval, oval)
        }
    },
    // beforeDestroy() {
    //     this.offAllListen();
    // },
    methods:{
        getnodeNames(){
            if(this.eduId == ''){
                this.eduId = 0
            }
            request({
                method: 'get',
                url: 'api/user/subject/getnodename?eduid='+this.eduId
            }).then(res=>{
                this.eduName = res.data
            })
        },
        // 清空搜索框-知识点
        closeSearch(val){
            if(val == ''){
                this.searchto();
            }
        },
        // 清空搜索框-章节
        closeSearch2(val){
            if(val == ''){
                this.searchto2();
            }
        },
        // 收藏到我的实验
        saveEx(index,item){
            this.ExTitle = item.title
            this.ExId = item.id
            request({
                method:'get',
                url:'api/jdResources/'+item.id+'?isStudy='+item.isStudy
            }).then(res=>{
                // 获取知识点
                this.Treeid = []
                for(let i in res.data.Tree){
                    this.Treeid.push(res.data.Tree[i].id)
                }
                // 获取章节
                this.Chapterid = []
                for(let i in res.data.jdchaptertree){
                    this.Chapterid.push(res.data.jdchaptertree[i].id)
                }
            })
            if(item.isStudy == 1){
                this.$notify({
                    message:'Please contact the administrator or try again',
                    type:'error',
                    duration: 1500
                })
            }else{
                if(item.isStudy == 0 && item.collect == 0){
                    this.$confirm('Do you want to collect this experiment into my experiment？', 'Tips', {
                    confirmButtonText: 'Confirm',
                    cancelButtonText: 'Cancel',
                    cancelButtonClass: 'messageBox-btnFEN',
                    confirmButtonClass: 'messageBox-btnTEN',
                    type: 'warning',
                    }).then(() => {
                        request({
                            method:'post',
                            url:'api/updateUserCollect?'+'resourcesId='+item.id+'&userId='+this.userId+'&chapterIds='+this.Chapterid+'&treeIds='+this.Treeid
                        }).then(res=>{
                            if(res.data == "收藏成功"){
                                this.$notify({
                                    message:'Collection successful, can be viewed in my experiment',
                                    type:'success',
                                    duration: 1500
                                })
                                if(this.isTable == 99){
                                    this.getList()
                                }else if(this.isTable == 98){
                                    this.getList2()
                                }
                            }
                        })
                    }).catch(() => {
                    });   
                }else{
                    this.$confirm('Do you want to remove this experiment from my experiment？', 'Tips', {
                    confirmButtonText: 'Confirm',
                    cancelButtonText: 'Cancel',
                    cancelButtonClass: 'messageBox-btnFEN',
                    confirmButtonClass: 'messageBox-btnTEN',
                    type: 'warning',
                    }).then(() => {
                        request({
                            method:'post',
                            url:'api/updateUserCollect?'+'resourcesId='+item.id+'&userId='+this.userId+'&chapterIds=0'+'&treeIds=0'
                        }).then(res=>{
                            if(res.data == "取消收藏"){
                                this.$notify({
                                    message:'The experiment has been removed from my experiment',
                                    type:'success',
                                    duration: 1500
                                })
                                if(this.isTable == 99){
                                    this.getList()
                                }else if(this.isTable == 98){
                                    this.getList2()
                                }
                            }
                        })
                    }).catch(() => {
                    });   
                }
            }
        },
        // 收藏
        toggle(index,item){
            request({
                method:'post',
                url:'api/updateUserCollect?'+'resourcesId='+item.id+'&userId='+this.userId
            }).then(res=>{
                if(res.data == "收藏成功"){
                    this.$notify({
                        message:'Collection successful',
                        type:'success',
                        duration:1500
                    })
                    this.dataList[index].collect=!this.dataList[index].collect
                }else{
                    this.$notify({
                        message:'Canceled collection',
                        type:'success',
                        duration:1500
                    })
                    this.dataList[index].collect=!this.dataList[index].collect
                }
            })
        },
        //获取info
        getinfo(){
          request({
            method:'get',
            url:'auth/info'
          }).then(res=>{
            this.swit = true
            this.swit2 = false
            this.inpu = true
            this.inpu2 = false
            this.pagin = true
            this.pagin2 = false
            this.userId = res.jwtUser.id
            this.infoNumber = 0
            this.getList()
            this.getProp()
          }).catch(err=>{
            this.$confirm('The current account is already logged in on another device, Or not in use time', 'Tips', {
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                cancelButtonClass: 'messageBox-btnFEN',
                confirmButtonClass: 'messageBox-btnTEN',
                type: 'warning',
            }).then(() => {
                this.logout();
            }).catch(() => {
                this.logout();
            })
          })
        },
        //按知识点
        Rescreening(){
            this.$confirm('Do you want to reset the search content？', 'Tips', {
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            cancelButtonClass: 'messageBox-btnFEN',
            confirmButtonClass: 'messageBox-btnTEN',
            type: 'warning',
            }).then(() => {
                this.search = '';
                let page = {}
                page.pagesize = 12;
                page.pagenumber = 0;
                page.currentPage = 1;
                page.total = 0;
                page.search = '';
                this.pageData =page
                this.getList()
            }).catch(() => {      
            });
        },
        // 按章节
        Rescreening2(){
            this.$confirm('Do you want to reset the search content？', 'Tips', {
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            cancelButtonClass: 'messageBox-btnFEN',
            confirmButtonClass: 'messageBox-btnTEN',
            type: 'warning',
            }).then(() => {
                this.search = '';
                let page = {}
                page.pagesize = 12;
                page.pagenumber = 0;
                page.currentPage = 1;
                page.total = 0;
                page.search = '';
                this.pageData =page
                this.getList2()
            }).catch(() => {      
            });
        },
        //按知识点
        searchto(){
            var specialKey = "[`@~!#$^&*()=|%{}':;',[].<>/~！#￥……&*（）——|{}【】‘；：”“'。，、？]‘'";
            for(var i = 0;i<specialKey.length;i++){
                if(this.search == specialKey[i]){
                    this.$notify({
                        message:"This is an illegal character. Please confirm and enter",
                        type:'error',
                        duration: 1500
                    })
                    return
                }
            }
            this.pageData.pagenumber = 0;
            this.getList();
        },
        //按章节
        searchto2(){
            var specialKey = "[`@~!#$^&*()=|%{}':;',[].<>/~！#￥……&*（）——|{}【】‘；：”“'。，、？]‘'";
            for(var i = 0;i<specialKey.length;i++){
                if(this.search == specialKey[i]){
                    this.$notify({
                        message:"This is an illegal character. Please confirm and enter",
                        type:'error',
                        duration: 1500
                    })
                    return
                }
            }
            this.pageData.pagenumber = 0;
            this.getList2();
        },
        //按知识点搜索
        switcs(value){
          if(value == "全部"){
              this.isfree = ''
          }else{
              this.isfree = 0
          }
          this.pageData.total = 0;
          this.pageData.pagenumber = 0;
          this.getList()
        },
        //按章节搜索
        switcs2(value){
          if(value == "全部"){
              this.isfree = ''
          }else{
              this.isfree = 0
          }
          this.pageData.total = 0;
          this.pageData.pagenumber = 0;
          this.getList2()
        },
        infoex(item){
            if(item.collectFees == 1){
                this.$notify({
                message:'Sorry, you have not bought this experiment, please buy it first or contact the sales staff',
                type:'error',
                duration: 1500
              })
            }else{
                if(item.isStudy == 0){
                    this.$router.push({
                    path: "/infoEn",
                    query: {
                        infoId:item.id,
                        // infoTitle:item.title,
                        // infoPhoto:item.fileThumbnail,
                        infoBrowseNum:item.browseNum,
                        // infoAerage:item.average,
                        // infoScoringMan:item.scoringMan,
                        // infoTotalPoints:item.totalPoints,
                        infoNumber:this.infoNumber,
                        infoTreeId:this.eduId,
                        infoNodeName:this.eduName,
                        infoIsFree:this.isfree,
                        infoSearch:this.search,
                        infoStudy:item.isStudy,
                        infoisStudy:this.isStudy
                        }
                    });
                }
                // window.open(routeUrl .href, '_blank');
            }
        },
        // 手动清除监听
        // offAllListen(){
        //     this.bus.$off("switcS")
        //     this.bus.$off("switcS2")
        //     this.bus.$off("ificationS")
        //     this.bus.$off("ificationS2")
        //     this.bus.$off("ificationS3")
        // },
        // 传参
        getProp(){
            // 标签
            // this.bus.$on("myFun1",prop=>{
            //     this.themeType = prop;
            //     this.getList()
            // })
            //特色实验
            // this.bus.$on("myFun2",prop=>{
            // this.materialType = prop;
            // this.getList()
            // })
            this.bus.$on("switcS",prop=>{
                if(prop == 0){
                    this.eduId = '';
                }else{
                    this.eduId = prop;
                }
                this.eduName = '';
                this.pageData.total = 0;
                this.pageData.pagenumber = 0;
                this.infoNumber = 0
                this.getList()
                this.getnodeNames();
            })
            this.bus.$on("switcS2",prop=>{
                if(prop == 0){
                    this.eduId = '';
                }else{
                    this.eduId = prop;
                }
                this.eduName = '';
                this.pageData.total = 0;
                this.pageData.pagenumber = 0;
                this.infoNumber = 1
                this.getList2()
                this.getnodeNames();
            })
            //按知识点
            this.bus.$on("ificationS",prop=>{
                this.eduId = prop.id;
                this.eduName = prop.englishNodeName
                this.pageData.pagenumber = 0;
                this.page = 1;
                this.pagin = true;
                this.pagin2 = false;
                this.getList()
            })
            //按章节
            this.bus.$on("ificationS2",prop=>{
                this.eduId = prop.id;
                this.eduName = prop.englishNodeName
                this.pageData.pagenumber = 0;
                this.page = 1;
                this.pagin = false;
                this.pagin2 = true;
                this.getList2()
            })
            //按章节
            this.bus.$on("ificationS3",prop=>{
                this.eduId = prop.id;
                this.eduName = prop.englishNodeName
                this.pageData.pagenumber = 0;
                this.page = 1;
                this.pagin = true;
                this.pagin2 = false;
                this.getList()
            })
        },
        //通过知识点获取
        getList(type){
            this.isTable = 99
            this.inpu = true
            this.inpu2 = false
            this.swit = true
            this.swit2 = false
            this.pagin = true
            this.pagin2 = false
            this.loading = true
            request({
                 method:'get',
                 url: 'api/trees?'+'eduTreeIds='+this.eduId+'&page='+this.pageData.pagenumber+'&size='+this.pageData.pagesize+'&themeType='+this.themeType+'&materialType='+this.materialType+'&collectFees='+this.isfree+'&englishTitle='+this.search+'&shelves=1'+'&noderes=1'+'&sort=stick%2Cdesc'+'&userId='+this.userId+'&isStudy=0'+'&userCollect=0&englishBS=2'
            }).then(res=>{
                this.dataList = res.data.content;
                let changeimg = res.data.content;
                this.imageChanges = [];
                for(let i in changeimg){
                    if(changeimg[i].englishFileThumbnail == null){
                        this.imageChanges.push(changeimg[i].englishFileThumbnail)
                    }else{
                        this.imageChanges.push((changeimg[i].englishFileThumbnail.split("").reverse().join("").substring(4)).split("").reverse().join("")+'_480x270.png')
                    } 
                }
                // console.log((this.changeimg[0].fileThumbnail.split("").reverse().join("").substring(4)).split("").reverse().join("")+'_480x270.png')
                var temp = {}
                temp.pagesize=this.pageData.pagesize;
                temp.pagenumber=this.pageData.pagenumber;
                temp.total =Number(res.data.totalElements);
                this.pageData=temp
                this.loading = false
                this.itemOk = true
                // 滚动到顶部
                let currentPosition,timer;
                let speed=30;
                setTimeout(() => {
                    timer=setInterval(function(){
                        currentPosition=document.documentElement.scrollTop || document.body.scrollTop;
                        currentPosition-=speed;
                        if(currentPosition>0){
                            window.scrollTo(0,currentPosition);
                        }else{
                            window.scrollTo(0,0);
                            clearInterval(timer);
                        }
                    },1);
                }, 100)
            }).catch(err=>{
                this.$confirm('The current account is already logged in on another device, Or not in use time', 'Tips', {
                    confirmButtonText: 'Confirm',
                    cancelButtonText: 'Cancel',
                    cancelButtonClass: 'messageBox-btnFEN',
                    confirmButtonClass: 'messageBox-btnTEN',
                    type: 'warning',
                }).then(() => {
                    this.logout();
                })
            })
        },
        logout() {
            if(localStorage.getItem('language') == 'en'){
                this.$store.dispatch('LogOut').then(() => {
                location.reload() // 为了重新实例化vue-router对象 避免bug
                })
                if(localStorage.getItem('langEn') == '' && localStorage.getItem('language') == 'en'){
                this.$router.push({path:'/index'});
                localStorage.setItem('language','en');
                }else if(localStorage.getItem('langEn') == 'en' && localStorage.getItem('language') == 'en'){
                this.$router.push({path:'/index?lan=en'})
                }else if(localStorage.getItem('langEn') == 'zh' && localStorage.getItem('language') == 'zh'){
                this.$router.push({path:'/index?lan=zh'})
                }
            }else if(localStorage.getItem('language') == 'zh'){
                this.$store.dispatch('LogOut').then(() => {
                location.reload() // 为了重新实例化vue-router对象 避免bug
                })
                if(localStorage.getItem('langEn') == '' && localStorage.getItem('language') == 'zh'){
                this.$router.push({path:'/index'});
                }else if(localStorage.getItem('langEn') == 'en' && localStorage.getItem('language') == 'en'){
                this.$router.push({path:'/index?lan=en'})
                }else if(localStorage.getItem('langEn') == 'zh' && localStorage.getItem('language') == 'zh'){
                this.$router.push({path:'/index?lan=zh'})
                }
            }
        },
        //通过章节获取
        getList2(type){
            this.isTable = 98
            this.inpu = false
            this.inpu2 = true
            this.swit = false
            this.swit2 = true
            this.pagin = false
            this.pagin2 = true
            this.loading = true
            request({
                 method:'get',
                 url: 'api/chaptertrees?'+'eduTreeIds='+this.eduId+'&page='+this.pageData.pagenumber+'&size='+this.pageData.pagesize+'&themeType='+this.themeType+'&materialType='+this.materialType+'&collectFees='+this.isfree+'&englishTitle='+this.search+'&shelves=1'+'&noderes=1'+'&sort=stick%2Cdesc'+'&userId='+this.userId+'&isStudy=0'+'&userCollect=0'
            }).then(res=>{
                this.dataList = res.data.content;
                let changeimg = res.data.content;
                this.imageChanges = [];
                for(let i in changeimg){
                    if(changeimg[i].fileThumbnail == null){
                        this.imageChanges.push(changeimg[i].fileThumbnail)
                    }else{
                        this.imageChanges.push((changeimg[i].fileThumbnail.split("").reverse().join("").substring(4)).split("").reverse().join("")+'_480x270.png')
                    }
                }
                var temp = {}
                temp.pagesize=this.pageData.pagesize;
                temp.pagenumber=this.pageData.pagenumber;
                temp.total =Number(res.data.totalElements);
                this.pageData=temp
                this.loading = false
                this.itemOk = true
                // 滚动到顶部
                let currentPosition,timer;
                let speed=30;
                setTimeout(() => {
                    timer=setInterval(function(){
                        currentPosition=document.documentElement.scrollTop || document.body.scrollTop;
                        currentPosition-=speed;
                        if(currentPosition>0){
                            window.scrollTo(0,currentPosition);
                        }else{
                            window.scrollTo(0,0);
                            clearInterval(timer);
                        }
                    },1);
                }, 100)
                
            })
        },
        pageChange(data){
            this.pageData.pagenumber = data-1;
            this.getList()
        },
        pageChange2(data){
            this.pageData.pagenumber = data-1;
            this.getList2()
        },
    }
    
}
</script>

<style scoped>
    @import '../styles/pad.css';
    @import '../styles/search.css';
.Experimentlist{
    width: 100%;height: 100%;background: #fff;
    float:left;
}
.contentl{
    width:98%;
    border-bottom: 1px solid #eee;
    height: 65px;
    margin-left: 1%;
    margin-bottom: 10px;
}
.tit{
    margin: 0;
    line-height: 65px;
    font-size: 20px;
    font-weight: 400;
    float: left;
    color: #333;
}
.rowtab2{
    float: left;
    font-size: 14px;
    margin-top: 32px;
    margin-left: 805px;
}
.buttontab2{
    height: 14px;
    padding-right: 10px;
    border-right: 1px solid #ccc;
}
.buttontab2:last-of-type{
    padding-left: 5px;
    border-right: none;
    padding-right: 0;
}
.contentl>ul{
    height: 65px;
    line-height: 65px;
    margin: 0;
    padding: 0;
    list-style: none;
    padding: 0 126px;
    float: right;
}
.contentl>ul>li{
    width: auto;
    float: left;
    margin: 0;
    padding: 0;
    list-style: none;
}
.list{
    width: 100%;
    height: 100%;
    float:left;
}
.item{
    /* width:30%; */
    float: left;
    margin-bottom: 20px;
    z-index: 10;
}
.itemIn{
    width:100%;
    float: left;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
}
.itemIn:hover{
    transition: all 0.2s linear 0s;
    transform: scale(1.01);
    box-shadow: 4px 7px 18px 0px rgba(0, 0, 0, 0.2);
}
.itemIn:hover .collection{
    display: block;
}
.pic{
    width: 100%;
    text-align: center;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    height:calc( (23.1vw / 16) * 9);
     background: #979693b8;
}
.pic /deep/ .el-image{
    width:100%;
    height: 100%;
    float:left;
}
.pic img{
    width:100%;
    height: 100%;
}
/* 同步 探究 */
.tbtj{
    width: 14%;
    height: 30px;
    line-height: 30px;
    background-color: #F38F38;
    border-radius: 2px;
    position: absolute;
    left: 3%;
    top: 5%;
    color: #E8E8E8;
    font-size: 18px;
}
.left-top{
    font-weight: 400;
}
/* 收藏 */
.collection{
    width: 12%;
    height: 14.5%;
    position: absolute;
    right: 3%;
    top: 5%;
    background: #fff;
    padding: 8px;
    border-radius: 4px;
    display: none;
    cursor: pointer;
}
.list /deep/ .image-slot{
    width:100%;
    height:100%;
    float: left;
}
.collection-2{
    width: 100%;
    height: 100%;
    background-image: url(../../assets/images/portal/collection2.png) !important;
    background-size: 100%;
    animation: spin 0.5s ease-in-out;
}
@keyframes spin {
                0%{
                    transform: scale(1);  /*开始为原始大小*/
                }
                100% {
                    transform: scale(1.1);
                }
            }
.collection>i{
    float: left;
    width: 100%;
    height: 100%;
}
.collectioni{
    width: 100%;
    height: 100%;
    background-image: url(../../assets/images/portal/collection.png);
    background-size: 100%;
}
.box3{
    background-color: #00A0E9;
}
/* 收费 免费 */
.box{
    width: 0;
    height: 0;
    border-top: 60px solid  #46b8da;
    border-left: 60px solid transparent;
    margin-bottom: -100px;
    position: absolute;
    right: 0;
    top: 0;
    float: right !important;
    box-sizing: border-box;
    z-index: 200;
}
.box2{
    border-top: 60px solid  #f19345;
}
.right-top{
    width: 60px;
    font-weight: 600;
    color: #fff;
    position: relative;
    right: 50px;
    top: -50px;
    display: block;
    box-sizing: border-box;
    /* transform: rotate(80deg); */
    -webkit-transform:rotate(45deg)
}
/* .pic:hover .pichover{
    display: block;
    align-items:center;
    display: -webkit-flex;
    justify-content:center;
    cursor: pointer;
}
.pichover{
    width: 100%;
    height: 100%;
    font-size: 22px;
    font-weight: 600;
    position: absolute;
    top: 0;
    left: 0;
    background: #fff;
    opacity: 0.8;
    display: none;
    transform: all 0.7s;
} */

.titl{
    padding-top: 4%;
    padding-left: 2%;
    font-size: 18px;
    color: #333;
    font-weight: 400;
    width: 100%;
    margin: 0;
    float: left;
}

/* new */
.Exinput{
    width: 376px;
}
.Exinput /deep/ .el-input__inner{
    height: 34px;
    /* border-radius: inherit; */
    border-color: #ccc;
}
.boxxx{
    position: fixed;
    left: 0;
    right: 0;
    top:0;
    bottom: 0;
    background-color: rgba(0, 0, 0, .4);
    z-index:2001;
}
.transition-box{
    width: 666px;
    /* height: auto; */
    position:absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    background-color: #fff;
    padding-bottom: 20px;
    overflow: hidden;
    overflow-y: auto;
}
.head{
    height: 100px;
    line-height: 100px;
    text-align: center;
    position: relative;
    font-size: 26px;
    color: #333;
}
.head p{
    position: absolute;
    margin: 0;
    right: 0;
    text-indent: 0;
    font-size: 24px;
    margin:20px 20px 0 0;
    cursor: pointer;
    color: #999;
    font-weight: bold;
}
.content .joinBtn{
    color:#fff !important;
    background-color: #F38F38 !important;
}
.content{
    width: 100%;
    height: auto;
    float: left;
    padding: 0 90px;
}
.content ul{
    margin: 0;
    padding: 0;
    float: left;
}
.content ul li{
    list-style: none;
    float: left;
    margin-bottom: 30px;
    font-size: 18px;
    color: #333;
    width:100%;
}
.content ul li:nth-of-type(3) .joinBtn{
    margin-left: 20px;
}
.content ul li:nth-of-type(3) .joinBtn:focus, .joinBtn:hover{
    border-color: #F38F38;
    color:#F38F38;
    background-color: #fff;
    border-radius: 2px;
}
.content ul li:nth-of-type(4) .joinBtn{
    margin-left: 20px;
}
.content ul li:nth-of-type(4) .joinBtn:focus, .joinBtn:hover{
    border-color: #F38F38;
    color:#F38F38;
    background-color: #fff;
    border-radius: 2px;
}
.content ul li:last-of-type{
    width: 100%;
    text-align: center;
    margin-bottom: 0;
}
.content /deep/ .el-button--warning{
    font-size: 18px !important;
    color: #fff !important;
    padding:12px 32px !important;
    background-color:#F38F38;
}
.content /deep/ .el-cascader .el-input.is-focus .el-input__inner{
    border-color: #F38F38;
}
.content /deep/ .el-cascader{
    width: 100%;
    margin-top: 14px;
}
.content /deep/ .el-cascader .el-input__inner{
    height: 32px;
    border-radius: 2px;
}
.content /deep/ .el-cascader .el-input__icon{
    line-height: 32px;
}
.content /deep/ .joinBtn{
    color:#F38F38;
    border-color:#F38F38;
    border-radius: 2px;
    padding: 5px 10px;
    font-size: 16px;
}
.el-rate{
    float: right;
    color:rgb(236, 111, 40)
}
.paginations{
    width: 100%;
    float: left;
    padding: 18px 20px;
}
.el-pagination{
    text-align: center;
    font-weight: 400;
}
/* Tips信息 */
.noshow{
    height: auto;
    text-align: center;
    margin-top: 166px;
}
.noshow>span{
    font-size: 32px;
    color: #999;
}
.noshow>p{
    margin-top: 69px;
    margin-bottom: 158px;
    width: 593px;
    height: 349px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
}
.noshow>p>img{
    width: 100%;
    height: 100%;
}
.isRecomm{
    width: 18px;
    height: 20px;
    float: left;
    margin-right: 9px;
    background-image: url(../../assets/images/portal/hot.png);
    background-size: 100%;
}
.titl .item{
    width: 90%;
    white-space:nowrap; text-overflow:ellipsis; -o-text-overflow:ellipsis; overflow:hidden;
}
.image-slot{
    width: 100%;
    height: 100%;
    float: left;
}
  @media (max-width: 375px){
    .paginations{
        padding: 20px 0;
    }
    .paginations>.el-pagination{
        width: 100%;
        padding: 0;
    }
    .break{
        display:none;
    }
    .rowtab2{
        position: absolute;
        left: 0px;
        font-size: 14px;
        margin-top: 32px;
        margin-left: 110px;
    }
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 1px 10px 0 0;
        padding: 0;
        list-style: none;
        padding: 0;
        float: right;
    }
    .contentl>ul>li{
        width: auto;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    /* 分页 */
    .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background:#F38F38;
        color: #fff;
    }
     /* 搜索框 */
    .contentl /deep/ .input-with-select>.el-input__inner{
        background: #f6f6f6;
        color: #a0a0a0;
        font-size: 14px;
    }
    .contentl /deep/ .el-input-group__append button.el-button{
        background-color: #fff;
    }
    /* main */
    .contentl /deep/ .buttontab2>.el-radio-button__inner{
        border: none;
        padding: 0;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
        color: #F38F38;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background: #fff;
        color: #F38F38;
        box-shadow: none;
    }
    .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
        border-left: none;
    }
    .contentl /deep/ .el-button+.el-button{
        margin-left: 20px;
    }
  }
  @media screen and (min-width:376px) and (max-width: 768px){
    .break{
        display:none;
    }
    .rowtab2{
        position: absolute;
        left: 0px;
        font-size: 14px;
        margin-top: 32px;
        margin-left: 340px;
    }
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 1px 0 0 0;
        padding: 0;
        list-style: none;
        padding: 0;
        float: right;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    /* 分页 */
    .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background:#F38F38;
        color: #fff;
    }
     /* 搜索框 */
    .contentl /deep/ .input-with-select>.el-input__inner{
        background: #f6f6f6;
        color: #a0a0a0;
        font-size: 16px;
    }
    .contentl /deep/ .el-input-group__append button.el-button{
        background-color: #fff;
    }
    /* main */
    .contentl /deep/ .buttontab2>.el-radio-button__inner{
        border: none;
        padding: 0;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
        color: #F38F38;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background: #fff;
        color: #F38F38;
        box-shadow: none;
    }
    .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
        border-left: none;
    }
    .contentl /deep/ .el-button+.el-button{
        margin-left: 20px;
    }
  }
  @media screen and (min-width:769px) and (max-width: 1024px){
    .break{
        display:none;
    }
    .rowtab2{
        position: absolute;
        left: 0px;
        font-size: 14px;
        margin-top: 32px;
        margin-left: 360px;
    }
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 1px 0 0 0;
        padding: 0;
        list-style: none;
        padding: 0;
        float: right;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    /* 分页 */
    .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background:#F38F38;
        color: #fff;
    }
     /* 搜索框 */
    .contentl /deep/ .input-with-select>.el-input__inner{
        background: #f6f6f6;
        color: #a0a0a0;
        font-size: 16px;
    }
    .contentl /deep/ .el-input-group__append button.el-button{
        background-color: #fff;
    }
    /* main */
    .contentl /deep/ .buttontab2>.el-radio-button__inner{
        border: none;
        padding: 0;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
        color: #F38F38;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background: #fff;
        color: #F38F38;
        box-shadow: none;
    }
    .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
        border-left: none;
    }
    .contentl /deep/ .el-button+.el-button{
        margin-left: 20px;
    }
  }
  @media screen and (min-width:1025px) and (max-width:1366px){
    .break{
        display:none;
    }
    .rowtab2{
        float: left;
        margin-left: 20px;
    }
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 0;
        padding: 0;
        list-style: none;
        float: right;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    /* Tips信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 95px;
    }
    .noshow>span{
        font-size: 24px;
        color: #999;
    }
    .noshow>p{
        margin-top: 49px;
        margin-bottom: 62px;
        width: 422px;
        height: 248px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
    /* 分页 */
    .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background:#F38F38;
        color: #fff;
    }
     /* 搜索框 */
    .contentl /deep/ .input-with-select>.el-input__inner{
        background: #f6f6f6;
        color: #a0a0a0;
        font-size: 16px;
    }
    .contentl /deep/ .el-input-group__append button.el-button{
        background-color: #fff;
    }
    /* main */
    .contentl /deep/ .buttontab2>.el-radio-button__inner{
        border: none;
        padding: 0;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
        color: #F38F38;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background: #fff;
        color: #F38F38;
        box-shadow: none;
    }
    .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
        border-left: none;
    }
    .contentl /deep/ .el-button+.el-button{
        margin-left: 20px;
    }
  }
  @media screen and (min-width:1367px) and (max-width:1440px){
    .rowtab2{
        position: absolute;
        left: 200px;
        font-size: 14px;
        margin-top: 32px;
        margin-left: 710px;
    }
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 0;
        padding: 0;
        list-style: none;
        float: right;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    /* Tips信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 95px;
    }
    .noshow>span{
        font-size: 24px;
        color: #999;
    }
    .noshow>p{
        margin-top: 49px;
        margin-bottom: 62px;
        width: 422px;
        height: 248px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
    /* 分页 */
    .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background:#F38F38;
        color: #fff;
    }
     /* 搜索框 */
    .contentl /deep/ .input-with-select>.el-input__inner{
        background: #f6f6f6;
        color: #a0a0a0;
        font-size: 16px;
    }
    .contentl /deep/ .el-input-group__append button.el-button{
        background-color: #fff;
    }
    /* main */
    .contentl /deep/ .buttontab2>.el-radio-button__inner{
        border: none;
        padding: 0;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
        color: #F38F38;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background: #fff;
        color: #F38F38;
        box-shadow: none;
    }
    .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
        border-left: none;
    }
    .contentl /deep/ .el-button+.el-button{
        margin-left: 20px;
    }
  }
  @media screen and (min-width:1441px) and (max-width:1600px){
    .rowtab2{
        position: absolute;
        left: 200px;
        font-size: 14px;
        margin-top: 32px;
        margin-left: 860px;
    }
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 0;
        padding: 0;
        list-style: none;
        float: right;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    /* Tips信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 117px;
    }
    .noshow>span{
        font-size: 26px;
        color: #999;
    }
    .noshow>p{
        margin-top: 55px;
        margin-bottom: 96px;
        width: 474px;
        height: 279px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
    /* 分页 */
    .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background:#F38F38;
        color: #fff;
    }
     /* 搜索框 */
    .contentl /deep/ .input-with-select>.el-input__inner{
        background: #f6f6f6;
        color: #a0a0a0;
        font-size: 16px;
    }
    .contentl /deep/ .el-input-group__append button.el-button{
        background-color: #fff;
    }
    /* main */
    .contentl /deep/ .buttontab2>.el-radio-button__inner{
        border: none;
        padding: 0;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
        color: #F38F38;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background: #fff;
        color: #F38F38;
        box-shadow: none;
    }
    .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
        border-left: none;
    }
    .contentl /deep/ .el-button+.el-button{
        margin-left: 20px;
    }
  }
  @media screen and (min-width:1601px) and (max-width:1920px){
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 0;
        padding: 0;
        list-style: none;
        float: right;
    }
    .rowtab2{
        position: absolute;
        left: 600px;
        font-size: 14px;
        margin-top: 32px;
        margin-left: 805px;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    /* Tips信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 166px;
    }
    .noshow>span{
        font-size: 32px;
        color: #999;
    }
    .noshow>p{
        margin-top: 69px;
        margin-bottom: 158px;
        width: 593px;
        height: 349px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
    /* 分页 */
    .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background:#F38F38;
        color: #fff;
    }
     /* 搜索框 */
    .contentl /deep/ .input-with-select>.el-input__inner{
        background: #f6f6f6;
        color: #a0a0a0;
        font-size: 16px;
    }
    .contentl /deep/ .el-input-group__append button.el-button{
        background-color: #fff;
    }
    /* main */
    .contentl /deep/ .buttontab2>.el-radio-button__inner{
        border: none;
        padding: 0;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
        color: #F38F38;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background: #fff;
        color: #F38F38;
        box-shadow: none;
    }
    .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
        border-left: none;
    }
    .contentl /deep/ .el-button+.el-button{
        margin-left: 20px;
    }
  }
  @media screen and (min-width:1921px) and (max-width:2048px){
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 0;
        padding: 0;
        list-style: none;
        float: right;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    /* Tips信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 182px;
    }
    .noshow>span{
        font-size: 34px;
        color: #999;
    }
    .noshow>p{
        margin-top: 74px;
        margin-bottom: 122px;
        width: 633px;
        height: 372px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
    /* 分页 */
    .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background:#F38F38;
        color: #fff;
    }
     /* 搜索框 */
    .contentl /deep/ .input-with-select>.el-input__inner{
        background: #f6f6f6;
        color: #a0a0a0;
        font-size: 16px;
    }
    .contentl /deep/ .el-input-group__append button.el-button{
        background-color: #fff;
    }
    /* main */
    .contentl /deep/ .buttontab2>.el-radio-button__inner{
        border: none;
        padding: 0;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
        color: #F38F38;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background: #fff;
        color: #F38F38;
        box-shadow: none;
    }
    .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
        border-left: none;
    }
    .contentl /deep/ .el-button+.el-button{
        margin-left: 20px;
    }
  }
  @media (min-width:2049px){
    .paginations{
        padding: 40px 0;
    }
    .rowtab2{
        position: absolute;
        left: 1150px;
        font-size: 14px;
        margin-top: 32px;
        margin-left: 805px;
    }
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 0;
        padding: 0;
        list-style: none;
        
        float: right;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    /* Tips信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 248px;
    }
    .noshow>span{
        font-size: 44px;
        color: #999;
    }
    .noshow>p{
        margin-top: 92px;
        margin-bottom: 246px;
        width: 791px;
        height: 465px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
    /* 分页 */
    .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background:#F38F38;
        color: #fff;
    }
     /* 搜索框 */
    .contentl /deep/ .input-with-select>.el-input__inner{
        background: #f6f6f6;
        color: #a0a0a0;
        font-size: 16px;
    }
    .contentl /deep/ .el-input-group__append button.el-button{
        background-color: #fff;
    }
    /* main */
    .contentl /deep/ .buttontab2>.el-radio-button__inner{
        border: none;
        padding: 0;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
        color: #F38F38;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background: #fff;
        color: #F38F38;
        box-shadow: none;
    }
    .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
        border-left: none;
    }
    .contentl /deep/ .el-button+.el-button{
        margin-left: 20px;
    }
  }
    [v-cloak] {
        display: none;
    }
</style>

<style rel="stylesheet/scss" lang="scss">
    .messageBox-prompt-test .el-button--primary{
        background-color:#F38F38;
        border-color:#F38F38;
    }
    .messageBox-prompt-test .el-button--default:hover{
        background-color:rgba($color: #F38F38, $alpha: 0.2);
        border-color:rgba($color: #F38F38, $alpha: 0.2);
        color: #F38F38;
    }
</style>


// WEBPACK FOOTER //
// src/components/langChoiceEn/shiyanListS.vue